import { Skeleton, Col, Row, Space } from 'antd';
import React from 'react';
import styles from './CardSkeleton.module.css';

interface Props {
	totalCards: number;
}

const CardSkeleton = (props: Props): React.JSX.Element => {
	const cards = Array.from({ length: props.totalCards });

	return (
		<Row gutter={{ xs: 0, sm: 12, md: 16, lg: 16, xl: 24 }}>
			{cards.map((_, index) => (
				<Col key={index} xs={24} sm={12} md={12} lg={8} xl={6} xxl={6}>
					<article className={styles.Card}>
						<div className={styles.Header} />
						<div className={styles.Details}>
							<div className={styles.Title}>
								<Skeleton active title={false} paragraph={{ rows: 2, width: ['90%', '70%'] }} />
							</div>
							<div className={styles.Meta}>
								<Skeleton active title={false} paragraph={{ rows: 2, width: ['50%', '60%'] }} />
							</div>
							<Space>
								<Skeleton.Button active shape="circle" size="default" />
								<Skeleton.Button active shape="circle" size="default" />
								<Skeleton.Button active shape="circle" size="default" />
							</Space>
						</div>
					</article>
				</Col>
			))}
		</Row>
	);
};

export default CardSkeleton;
